import { Box, Typography, CircularProgress } from "@mui/material";

export default function SplashScreen() {
  return (
    <Box
      position="fixed"
      top={0}
      left={0}
      width="100vw"
      height="100vh"
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      sx={{ bgcolor: "#F9FAFB", zIndex: 9999 }}
      aria-label="Loading screen"
    >
      <CircularProgress
        size={64}
        thickness={5}
        sx={{ color: "#2563EB", mb: 3 }}
        aria-busy="true"
      />
      <Typography
        fontFamily="Space Grotesk, sans-serif"
        textAlign="center"
        fontWeight={700}
        fontSize={24}
        color="#2563EB"
        mt={2}
      >
        Loading...
      </Typography>
    </Box>
  );
}
